/**
 * Accessible Shop Filter
 *
 * Features:
 * - ARIA state management
 * - Live region announcements for screen readers
 * - No dependencies (Vanilla JS)
 */

const initShopFilter = (): void => {
    const filterButtons = document.querySelectorAll<HTMLButtonElement>('.shop-filter-btn');
    const shopsSection = document.getElementById('shops-section');
    const facilitiesSection = document.getElementById('facilities-section');
    const doctorsSection = document.getElementById('doctors-section');
    const statusRegion = document.getElementById('shop-filter-status');

    if (!shopsSection || !facilitiesSection || !doctorsSection || !statusRegion) {
        return;
    }

    const shopCards = shopsSection.querySelectorAll<HTMLElement>('.shop-card');

    const applyFilter = (filterValue: string): void => {
        // Filter shop cards
        shopCards.forEach(card => {
            const matches = filterValue === '*' || card.classList.contains(filterValue.replace('.', ''));
            card.hidden = !matches;
        });

        // Toggle sections
        if (filterValue === '*') {
            shopsSection.hidden = false;
            facilitiesSection.hidden = false;
            doctorsSection.hidden = false;
        } else if (filterValue === '.aerzte') {
            shopsSection.hidden = true;
            facilitiesSection.hidden = true;
            doctorsSection.hidden = false;
        } else if (filterValue === '.spezielle-einrichtungen-bueros') {
            shopsSection.hidden = true;
            facilitiesSection.hidden = false;
            doctorsSection.hidden = true;
        } else {
            shopsSection.hidden = false;
            facilitiesSection.hidden = true;
            doctorsSection.hidden = true;
        }
    };

    const announceResult = (filterValue: string, categoryName: string): void => {
        let message: string;
        const visibleShops = [...shopCards].filter(c => !c.hidden).length;

        if (filterValue === '*') {
            message = `${shopCards.length} Geschäfte werden angezeigt`;
        } else if (filterValue === '.aerzte') {
            const count = doctorsSection.querySelectorAll('.card').length;
            message = `${count} Arztpraxen werden angezeigt`;
        } else if (filterValue === '.spezielle-einrichtungen-bueros') {
            const count = facilitiesSection.querySelectorAll('li').length;
            message = `${count} Einrichtungen werden angezeigt`;
        } else {
            message = `${visibleShops} Geschäfte in "${categoryName}" gefunden`;
        }

        statusRegion.textContent = message;
    };

    filterButtons.forEach(btn => {
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            const filterValue = btn.dataset.filter ?? '*';

            // Update ARIA states
            filterButtons.forEach(b => b.setAttribute('aria-pressed', 'false'));
            btn.setAttribute('aria-pressed', 'true');

            applyFilter(filterValue);
            announceResult(filterValue, btn.textContent?.trim() ?? '');
        });
    });
};

export { initShopFilter };
